/*
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-02-13 14:28:31
 * @LastEditors: wangcan
 * @LastEditTime: 2023-03-30 17:50:55
 */
import Vue from 'vue'
import router from '@/router'
import cookies from 'vue-cookies'
import md5 from "js-md5";
import {
  login
} from "@/api/common";
import httpRequest from '@/utils/httpRequest'

/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}
export function loginMobile(){
  let uuid = getUUID();
  let params = {
    sign: md5(uuid + "mhys!123456"),
    uuid: uuid
  };
  login(params).then(({ data }) => {
    if (data && data.code === 200) {
      cookies.set("apiToken", data.data.apiToken, data.data.expire);
      this.$toast('已重新授权！3秒后返回');
      setTimeout(()=>{
        router.go(0)
      },3000) 
    } else {
      this.$toast(data.msg);
    }
  });
}